
document.addEventListener('DOMContentLoaded', function(){
  if ("virtualKeyboard" in navigator) {
    navigator.virtualKeyboard.overlaysContent = false;
  }
  setTimeout(function() {
    document.querySelector('.halo-popup').classList.add('init');
  }, 1000)

  // spd1 (zao#564): the country flags download only when she reaches for the country button (touch, hover, focus) or
  // opens the picker, not on every page view. The picker slides in over 0.8 s, which covers the flags' download.
  function flagsOn() {
    const countryPopup = document.querySelector('.halo-popup[data-popup-country]');
    if (countryPopup) countryPopup.classList.add('flags-on');
  }

  document.querySelectorAll('[data-open-popup]').forEach(function(element) {
    ['pointerdown', 'touchstart', 'mouseenter', 'focus'].forEach(function(type) {
      element.addEventListener(type, flagsOn, { once: true, passive: true });
    });
    element.addEventListener('click', function(event){
      flagsOn();
      let popup = this.getAttribute('data-popup-target');
      document.documentElement.classList.add('overflow-hidden');
      const popupElement = document.querySelector('.halo-popup[' + popup + ']');
      if (popupElement) {
        popupElement.classList.add('is-show');
      }
      
      setTimeout(function() {
        const searchInput = document.querySelector('.countrySwitcher__wrapperSearch__input');
        if (searchInput) {
          searchInput.focus();
        }
      }, 200);
    });
  });


  document.querySelectorAll('.halo-popup-close').forEach(function(element) {
    element.addEventListener('click', function(){
      document.documentElement.classList.remove('overflow-hidden');
      document.body.style.height = "auto";
      document.body.style.maxHeight = "unset"
      const closestPopup = this.closest('.halo-popup');
      if (closestPopup) {
        closestPopup.classList.remove('is-show');
      }
    });
  });

  document.querySelectorAll(".countryListWrap .disclosure__item>a.link").forEach(function(element) {
    element.addEventListener('click', function(){
      let val = this.getAttribute('data-value');
      const targetLink = document.querySelector(".sofsy-footer-localisation #FooterCountryList .link[data-value='"+ val +"']");
      if (targetLink) {
        targetLink.click();
      }
    });
  });

  const countrySearchInput = document.querySelector('.countrySwitcher__wrapperSearch__input');
  if (countrySearchInput) {
    countrySearchInput.addEventListener('keyup', function() {
      var search_val = this.value.toLowerCase();
      if(search_val == '') {
        document.querySelectorAll('.disclosure__item').forEach(function(element) {
          element.style.display = '';
        });
        document.querySelector('.halo-popup-content ul').classList.add('-nofilter');
      } else {
        document.querySelector('.halo-popup-content ul').classList.remove('-nofilter');
        document.querySelectorAll('.disclosure__item').forEach(function(element) {
          const linkText = element.querySelector('.link').textContent.toLowerCase();
          if(linkText.indexOf(search_val) != -1) {
            element.style.display = '';
          } else {
            element.style.display = 'none';
          }
        });
      }
    });
  }

});